import { Text } from "react_reusable_components";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import Styles from "./UserListingContainer.module.scss";

export const columns = (intl, isMd) =>
  [
    {
      dataIndex: "name",
      key: "name",
      width: !isMd && "30%",
      title: (
        <Text className={Styles["header-text"]}>
          {getLocalizedMessage(intl, "userManagement.tableHeader.name")}
        </Text>
      ),
      render: (text) => (
        <Text type="secondary" className={Styles["text-style"]}>
          {text}
        </Text>
      ),
    },
    {
      dataIndex: "email",
      key: "email",
      width: isMd ? "20%" : "50%",
      title: (
        <Text className={Styles["header-text"]}>
          {getLocalizedMessage(intl, "userManagement.tableHeader.email")}{" "}
        </Text>
      ),
      render: (text) => (
        <Text
          type="secondary"
          className={`${Styles["text-style"]} ${Styles["no-capitalize"]} ${Styles["ellipsis-style"]}`}
        >
          {text}
        </Text>
      ),
    },
    isMd && {
      dataIndex: "mobile",
      key: "mobileNumber",
      title: (
        <Text className={Styles["header-text"]}>
          {getLocalizedMessage(intl, "userManagement.tableHeader.mobileNo")}
        </Text>
      ),
      render: (text) => (
        <Text type="secondary" className={Styles["text-style"]}>
          {text?.countryCode}&nbsp;
          {text?.number || "-"}
        </Text>
      ),
    },
    isMd && {
      dataIndex: "roles",
      key: "roles",
      title: (
        <Text className={Styles["header-text"]}>
          {getLocalizedMessage(intl, "userManagement.tableHeader.roles")}
        </Text>
      ),
      render: (text) => (
        <Text type="secondary" className={Styles["text-style"]}>
          {text?.map?.(({ fullName }) => fullName)?.join(", ")}
        </Text>
      ),
    },
    isMd && {
      dataIndex: "countryName",
      key: "countryName",
      title: (
        <Text className={Styles["header-text"]}>
          {getLocalizedMessage(intl, "userManagement.tableHeader.county")}
        </Text>
      ),
      render: (text) => (
        <Text type="secondary" className={Styles["text-style"]}>
          {text || "-"}
        </Text>
      ),
    },
  ].filter((item) => item);
